export default __webpack_public_path__ + "static/upwork-9e7c5a64bf8de1d9271fa386263fed2e.gif";